import Model from '@/models/Model.js';

export default class MeetingLink extends Model {
    static entity = 'meeting_links';

    static fields() {
        return {
            id: this.attr(null),
            meeting_user_id: this.attr(null),
            meeting_id: this.attr(null),
            link: this.attr(null),

            ...super.fields(),

            meeting_user: this.belongsTo('meeting_users', 'meeting_user_id'),
            meeting: this.hasMany('meetings', 'meeting_id'),
        };
    }
}
